<template>
  <div class="releaseAnnouncement">
    <Richtext style="margin-bottom:10px" ref="richText" cke-height="400px" cke-width="100%" cke-rows="10" cke-cols="80" @catchData="getData" :ckContent="content"></Richtext>
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
      <el-form-item label="获取码" prop="hqm">
      <!-- <div class="input1"> -->
        <el-input v-model="ruleForm.hqm" placeholder="请输入获取码"></el-input>
      <!-- </div> -->
      </el-form-item>
      <el-form-item>
      <!-- <div class="btns"> -->
        <el-button type="primary" @click="submitForm('ruleForm')" :disabled="btnFlag">确定</el-button>
        <el-button @click="resetForm('ruleForm')">重置</el-button>
      <!-- </div> -->
      </el-form-item>
    </el-form>

    <div style="margin: 10px auto;width:1000px;background;text-align:center;"> 
            <div class="d1" style="margin: 10px auto;width:500px;height:200px;text-align:left;">
                <p>预览</p>
                <el-card class="box-card" :body-style="{padding:'10px 15px'}" shadow="hover" >
                    <div v-html="content"></div>
                    <el-button v-if="ruleForm.hqm">获取</el-button>
                </el-card>
            </div>
        </div>
  </div>
</template>

<script>
import Richtext from './Richtext.vue'
export default {
  name: 'releaseAnnouncement',
  components: { Richtext },
  data(){
    return {
      content: '',//富文本的内容
      ruleForm:{
        hqm: '',
      },
      rules: {
        // hqm: [{ required: true, message: '请输入获取码', trigger: 'blur' }],
      },
      btnFlag: false,
    };
  },
  props: {
    msg: String
  },
  methods:{
    getData(data){
      // console.log(data);
      this.content = data;
    },
    submitForm(formName) {
      if(!this.content){
        this.$message.warning('请输入公告内容');
        return false;
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // console.log(this);
          let _this = this;
          _this.btnFlag=true;
          let data = {"hqm":this.ruleForm.hqm,"content":this.content};
          this.$axios.post('/ssBaseController/insertAnnouncement.do',data)
          .then(res => {  //res是返回结果
              // console.log(res)
              _this.$message({//消息提示框
                  message: '保存成功',
                  type: 'success',
                  showClose: true,//是否有关闭按钮
                  duration: 1000 //持续时间
              });
              _this.btnFlag=false;
          }).catch(err => { _this.btnFlag = false })
        } else {
          console.error('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      // this.content='';
      this.$refs.richText.emptyContent();
    }
  }
}
</script>

<style scoped>
.releaseAnnouncement{
  height:100%;
  width:1500px;
  margin: 0 auto;
  /* display:flex; */
  /* justify-content:left; */
  /* align-items: center; */
  /* text-align: left; */
  /* flex-direction:column; */
}
.el-form-item{
  /* display: block; */
  text-align: left;
  /* margin:10px 0 0 0;  */
  /* float:left; */
} 
.el-input {
  /* display: inline-block; */
  height: 47px;
  width: 200px;
}
.btns{
  /* margin:10px 0 0 10px;  */
  text-align: left;
}

.d1 .box-card {
    width: 400px;
    /* height:120px; */
    margin:10px auto 10px;
    max-height: 145px;
    /* min-height: 145px; */
    overflow: auto;
    border:2px solid red ;
}
</style>
